import { render, staticRenderFns } from "./SettingsJobs.vue?vue&type=template&id=79e5d3c2&scoped=true"
import script from "./SettingsJobs.vue?vue&type=script&lang=js"
export * from "./SettingsJobs.vue?vue&type=script&lang=js"
import style0 from "./SettingsJobs.vue?vue&type=style&index=0&id=79e5d3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5d3c2",
  null
  
)

export default component.exports